<template>
	<div class="ui-tab">
		<slot/>
	</div>
</template>

<script>
export default {

};
</script>

<style lang="scss">
.ui-tab {
	position: relative;
	z-index: 2;
	padding: 10px;
	background-color: #4d535d;
	box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
	border-bottom-right-radius: 4px;
	border-bottom-left-radius: 4px;
	border-top-right-radius: 4px;
}
</style>
